export const WebConstant = {
    IMAGE_URL : import.meta.env.VITE_REACT_APP_AWS_S3_URL,
    ABOUT:"about-us",
    TERMS:"terms-of-use",
    PRIVACY:"privacy-policy"
}
